import * as Sentry from "@sentry/nextjs";

// Identidad para Sentry. Hoy `Sentry.setUser` no se llama nunca, por eso todos
// los issues muestran "Users: 0" y es imposible saber a cuánta gente afecta cada
// error. Asignamos un id anónimo persistente (localStorage) a nivel app y lo
// enriquecemos con el email cuando se conoce (login / checkout).

const ANON_KEY = "bcm_uid";

export function getAnonId() {
  if (typeof window === "undefined") return null;
  try {
    let id = window.localStorage.getItem(ANON_KEY);
    if (!id) {
      id =
        window.crypto?.randomUUID?.() ??
        `anon-${Date.now()}-${Math.random().toString(16).slice(2)}`;
      window.localStorage.setItem(ANON_KEY, id);
    }
    return id;
  } catch {
    return null;
  }
}

// Identidad anónima base. Se llama una vez al iniciar el cliente.
export function initAnonUser() {
  const id = getAnonId();
  if (!id) return;
  try {
    Sentry.setUser({ id });
  } catch {}
}

// Enriquece el usuario con el email sin perder el id anónimo.
export function identifyUser(email) {
  const clean = String(email || "").trim().toLowerCase();
  if (!clean) return;
  try {
    Sentry.setUser({ id: getAnonId() || undefined, email: clean });
  } catch {}
}
